import React from "react";

export function PageNotFoundPage() {
    return <>
        Just where in tar-nation do ye think yer tryin' ta navigate to?
    </>;
}

